import React, {useState} from 'react';

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {Garlic} from '../../../../assets/images/images';
import Card from './investmentCard'
import '../style.scss'
import {MainHeading, RecordInterestModal} from "../../../index";

const responsive = {
  desktop: {
    breakpoint: {max: 3000, min: 1024},
    items: 2,
    slidesToSlide: 1 // optional, default to 1.
  },
  tablet: {
    breakpoint: {max: 1024, min: 464},
    items: 3,
    slidesToSlide: 2 // optional, default to 1.
  },
  mobile: {
    breakpoint: {max: 464, min: 0},
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  }
};

function Index(props) {
  const [modal, setModal] = useState(false);

  const [state, setState] = useState({
    values: {
      searchType: '',
      searchCategory: '',
      searchSubCategory: '',
      country: '',
      state: '',
      city: '',
      investmentClosingDate: '',
      priceFrom: '',
      priceTo: '',
      qty: '',
      qtyName: '',
      unit: '',
      currency: '',
      estimatedROI: '5',
      investmentReturnDate: '',
      clousreStatus: '',
      minimumShare: '',
      isShared: '',
      sharedQty: '',
      shareCurrency:'',
      preferedMethod: '',
      // ssoId: Number(user?.ssoId),
      details: '',
      image:'',
      unitValue: 'kg',
      quantity: '01',
    },
    errors: {
      bidId: "",
      price: "",
      qty: "",
      ssoId: "",
    },
  });
  return (
    <div className='feature-product-container' style={{}}>
      {/*<h2 className='black-color font-18 mb-0'></h2>*/}
      <MainHeading title={"Buyer Requests"} className={'mt-0'}/>
      <p className='desc color-green font-12 text-center mb-10 mt-0  p-0 mb-20'>
        Buyers on AgriLive are looking for the following products and services.
      </p>
      <Carousel
        swipeable={true}
        draggable={false}
        showDots={true}
        // renderButtonGroupOutside={true}
        partialVisbile={false}
        responsive={responsive}
        ssr={true} // means to render carousel on server-side.
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={1000}
        keyBoardControl={true}
        customTransition="all .5"
        transitionDuration={1000}
        containerClass="carousel-container"
        removeArrowOnDeviceType={["tablet", "mobile"]}
        // deviceType={this.props.deviceType}
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px "
      >
        {(props.data || []).map((item, index) => (
          <Card index={index} item={item} val={index} key={index}
                onClick={(event) => props.onSellerItemClick(index, item)}
                state={state} setState={setState}
                setModal={setModal}
                modal={modal}
          />
        ))}
      </Carousel>

      <RecordInterestModal open={modal} setOpen={setModal} state={state} setState={setState}/>

    </div>
  );
}

export default Index;
